import 'es6-promise/auto';
import Vue from "vue";
import '@/assets/site/css/global.scss';
import About from "@/components/website/About.vue";
import store from "./store";
import * as Sentry from '@sentry/browser';

// Do not run in dev because of Sentry bug -
// blocks console errors.
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://59a37de96e9a4004ad41c3a107f4abb3@sentry.io/1405164',
    integrations: [new Sentry.Integrations.Vue({ 
      Vue,
      attachProps: true
    })]
  });
}

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(About)
}).$mount("#app");